module.exports = __webpack_public_path__ + "img/2.9e9fe207.png";